import React from "react";

export const MAX_BUTTON_RIPPLE_LAYERS = 6;
export const MAX_RIPPLE_LAYOUT_RIPPLE_LAYERS = 6;

export function buildStyleVariables(visuals, unified, prefix) {
    if (!visuals || !Object.keys(visuals).length) return;

    let visualVariables = {};

    Object.keys(visuals).map(prop => {
        let transformName = p => '--' + prefix + p.charAt(0).toUpperCase() + p.slice(1);
        if (!unified.includes(prop)) {
            visualVariables[transformName(prop) + 'Light'] = visuals[prop][0]
            visualVariables[transformName(prop) + 'Dark'] = !!visuals[prop][1] ? visuals[prop][1] : visuals[prop][0];
        } else {
            visualVariables[transformName(prop)] = visuals[prop];
        }
    })

    return visualVariables
}

export function calculateRippleGeometry(e, ref) {

    let elem = ref;
    let buttonGeometry = elem.getBoundingClientRect();
    let width = elem.offsetWidth;
    let height = elem.offsetHeight;
    let diag = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2)) + 30; // cover diagonal + 5 for filling the button
    let mouseX = ((e.touches && e.touches[0].pageX || e.pageX) - buttonGeometry.x) - (diag / 2) - window.pageXOffset; // offset to get relative coords which are
    let mouseY = ((e.touches && e.touches[0].pageY || e.pageY) - buttonGeometry.y) - (diag / 2) - window.pageYOffset; // independent of window position
    let buttonX = (buttonGeometry.width / 2) - (diag / 2);
    let buttonY = (buttonGeometry.height / 2) - (diag / 2);
    let toRem = v => (v / 10) + 'rem'

    return {
        height: toRem(diag),
        width: toRem(diag),
        start: toRem(mouseX) + ', ' + toRem(mouseY),
        end: toRem(buttonX) + ', ' + toRem(buttonY),
    };
}

export function renderRippleLayers(state) {

    let {rippleLayers, config, currentLayerId, isHolding} = state;
    let {baseClass} = config;

    if (!rippleLayers || !rippleLayers.length) return null;

    return rippleLayers.map((layer, index) => {
        // pass ripple params to scss
        let params = {
            '--ripple-height': layer.height,
            '--ripple-width': layer.width,
            '--ripple-start': layer.start,
            '--ripple-end': layer.end,
        };
        let holdClass = '';
        // set holding feedback for user
        if (currentLayerId === index && !!isHolding) holdClass = ` ${baseClass}__ripple--hold`;

        return (
            <div
                className={`${baseClass}__ripple${holdClass}`}
                style={params}
                draggable='false'
                key={index + layer.start + layer.key}
            />
        )
    })
}